<template>
    <div style="width:100%; box-sizing: border-box; text-align: left;">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>


        <div style="width:100%; box-sizing:border-box; margin:0px auto; display:block;">

            <GrcNum ref="txtTagkod" v-model="txtTagkod" 
            grc_labeltext="Tagkód:"
            grc_placeholder="..."
            grc_currency="" grc_decimalplaces="0" grc_readonly="false"
            grc_textalign="left"
            grc_labelmode="" grc_labelwidth="200px" 
            v-on:grc-keydown-enter="SetControlToFocus('txtEmailCim');"
            style="margin-bottom:20px;"
            />

            <GrcText ref="txtEmailCim"
            grc_ispassword="false"
            grc_labeltext="E-mail cím:"
            grc_placeholder="..."
            grc_labelmode="" grc_labelwidth="200px" 
            v-on:grc-keydown-enter="SetControlToFocus('');"
            style="margin-bottom:20px;"
            grc_canshowpassword="mobilapp"
            />

            <div style="width:100%; box-sizing:border-box; text-align:center;">

                <span class="cms_linkbutton cms_linkbutton_2" style="margin: 4px 8px;" @click="btnOK_click">
                    <span><i class="fal fa-check" style="margin-right:10px;"></i>Rendben</span>
                </span>

                <span class="cms_linkbutton cms_linkbutton_CANCEL" style="margin: 4px 8px;" @click="btnMegsem_click">
                    <span><i class="fal fa-times" style="margin-right:10px;"></i>Mégsem</span>
                </span>

            </div>   

        </div>



    </div>
</template>

<script>

import GrcText from '../GrcComponents/GrcText.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'


export default {
  name: 'frmelfelejtettjelszo',
  components: {
      GrcDB,
      GrcDialog,
      GrcText,
      GrcNum
  },
  props: {

  },
  data () {
      return {
          WSPREFIX: "frmElfelejtettJelszo_",

          txtTagkod: 0,

      }
  },
  model: {

  },  
  methods:{



    JelszoKeydownOccured(pValue)
    {
      this.$refs.pwdstrength.SetValue(pValue);
    },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmElfelejtettJelszo", pCompName);
    },

    SetLang()
    {
        this.HideErrors();
    },


      SetControlToFocus(pNextComp)
      {
        if (pNextComp == "") { return; }
        this.$refs[pNextComp].SetFocus();
      },

      btnOK_click(e)
      {
        this.Mentes();
      },

      btnMegsem_click(e)
      {
        document.location = "dashboard";
      },

      HideErrors()
      {
        this.$refs.txtEmailCim.HideError();
        this.$refs.txtTagkod.HideError();
      },


      async Mentes()
      {
        this.HideErrors();

        var ErrorCompName = "";

        if (this.$refs.txtTagkod.GetValue() < 1)
        {
          if (ErrorCompName == "") { ErrorCompName = "txtTagkod"; }
          this.$refs.txtTagkod.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtEmailCim.GetText() == "")
        {
          if (ErrorCompName == "") { ErrorCompName = "txtEmailCim"; }
          this.$refs.txtEmailCim.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }


        if (ErrorCompName != "")
        {
          this.SetControlToFocus(ErrorCompName);
          return;
        }


        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sEmailCim: this.$refs.txtEmailCim.GetText(),
            iTagkod: this.$refs.txtTagkod.GetValue(),
            sIPAddress: "[IPADDRESS]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "SendPwd", QP).then(res => { Q = res; });

        
        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            await this.ShowInfo(Q.APPERR[0].ERR, 200);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        if (Q.RESULT[0].intResult == 1)
        {
            await this.ShowInfo(Q.RESULT[0].strResult, 200);

            document.location = "dashboard";
            return;
        }


        if (Q.RESULT[0].strResult != "")
        {
          await this.ShowInfo(Q.RESULT[0].strResult,200);
          document.location = "dashboard";
        }


      },

    async ShowInfo(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },





  },
  created()
  {

  },
  mounted()
  {
    this.SetLang();
  }

}


</script>


<style scoped>




</style>